import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import { Tooltip } from '@mui/material';
import { EventData } from '../types/PartnerTypes';


export default function EventsCarousal({events, partnerId}:{events:EventData[], partnerId:string}) {


  const handleIconClick = (event:EventData) => {
    // console.log(`Event clicked: ${event.eName}`);
    window.location.href = `https://www.plundr.besaksham.com/details/${partnerId}/event/${event.id}`;
  };
  
  return (<section>
    <div className="mx-auto max-w-screen-xl px-0 py-8 sm:px-6 sm:py-8 lg:px-0">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-4 lg:items-stretch">
        <div className="grid place-content-center rounded-lg bg-gray-800 border  border-solid p-4 sm:p-8">
          <div className="mx-auto max-w-md text-center lg:text-left">
            <header>
              <h2 className="text-xl font-semibold text-gray-100 sm:text-3xl">Events</h2>

              <p className=" mt-2 sm:mt-4 text-gray-300">
                Explore exciting events hosted by boom essentials!
              </p>
            </header>

          </div>
        </div>

        <div className="lg:col-span-3 lg:py-4">
          {events.length > 0 ? (
            <div className="flex overflow-x-auto pb-4 diff-scrollbar">
              <ul className="flex gap-4">
                {events.map((event,index)=>{
                  return(
                    <li key={index}>
                    <article  onClick={()=>handleIconClick(event)} className="rounded-xl cursor-pointer bg-white p-3 border border-gray-300 shadow-lg hover:shadow-xl">
                      <span>
                        <div className="relative flex items-end overflow-hidden rounded-xl">
                          <div className="relative w-full h-40 sm:h-52 aspect-[16/10]"> {/* Set a fixed height for landscape */}
                            <img
                              src={event.ePromoImage|| "https://images.unsplash.com/photo-1535525153412-5a42439a210d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
                              alt={event.eName + "Photo"}
                              className="object-cover w-full h-full transition-transform duration-300 transform hover:scale-105" // Added zoom effect on hover
                            />
                          </div>
                          <div className={`absolute top-3 right-3 inline-flex items-center rounded-xl px-2.5 shadow-2xl py-1 ${
                            event.isOpen ? 'bg-green-600' : 'bg-red-600'
                          }`}>
                            <span className="text-white ml-1 text-sm font-semibold">
                              {event.isOpen ? 'Live' : 'Event Closed'}
                            </span>
                          </div>
                        </div>
  
                        <div className="mt-1 p-2">
                        <div className="overflow-wrap">
                            <h2 className="text-slate-700 font-semibold">{event.eName}</h2>
                          </div>
               
                          <p className="text-slate-600 mt-1 text-sm whitespace-nowrap max-w-60 overflow-hidden text-ellipsis">{event.eGeoLocation?.placeName}</p>
                          <p className="text-slate-400 mt-1 text-sm">
                            {event.eStartTime && event.eEndTime && 
                              new Date(event.eStartTime.seconds * 1000).toLocaleDateString() === new Date(event.eEndTime.seconds * 1000).toLocaleDateString() 
                              ? new Date(event.eStartTime.seconds * 1000).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                })
                              : `${event.eStartTime ? new Date(event.eStartTime.seconds * 1000).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                }) : ""} - ${event.eEndTime ? new Date(event.eEndTime.seconds * 1000).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                }) : ""}`
                            }
                          </p>
  
                          <div className="mt-3 flex items-end justify-between">
                            <p>
                              <span className="text-lg font-bold text-blue-500">₹ {event.tickets?event.tickets[0]?.ticketPrice:0}</span>
                              <span className="text-slate-400 text-sm">/person</span>
                            </p>
  
                            <Tooltip title="Register Now" arrow> 
                              <div className="group inline-flex rounded-xl bg-blue-100 p-2 hover:bg-blue-200">
                              <ShoppingCartRoundedIcon fontSize='small' style={{ color: '#4284E2' }} />
                            </div>
                            </Tooltip>
                          </div>
                        </div>
                      </span>
                    </article>
                  </li> 
                  )
                }) }


              </ul>
            </div>
          ) : (
            <div className="flex h-full min-h-[100px] sm:min-h-[300px] items-center justify-center bg-white rounded-xl">
              <p className="text-xl text-gray-500">More exciting events coming soon!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </section>)

}
